"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftArrow = exports.RightArrow = exports.BaseArrow = exports.CarouselContent = exports.CarouselContentWrapper = exports.CarouselWrapper = exports.CarouselContainer = void 0;
const styles_1 = require("@mui/material/styles");
exports.CarouselContainer = (0, styles_1.styled)("div")({
    width: "100%",
    display: "flex",
    flexDirection: "column",
});
exports.CarouselWrapper = (0, styles_1.styled)("div")({
    display: "flex",
    width: "100%",
    position: "relative",
});
exports.CarouselContentWrapper = (0, styles_1.styled)("div")({
    overflow: "hidden",
    width: "100%",
    minHeight: "200px",
});
exports.CarouselContent = (0, styles_1.styled)("div", {
    shouldForwardProp: (props) => props !== "howMuchToShow",
})(({ howMuchToShow }) => {
    const setWidth = () => {
        if (howMuchToShow === 2) {
            return "50%";
        }
        return `calc(100%/${howMuchToShow})`;
    };
    return {
        display: "flex",
        transition: "all 250ms linear",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
            display: "none",
        },
        ["> div"]: {
            width: setWidth(),
            flexShrink: 0,
            flexGrow: 1,
            marginTop: 0,
            marginRight: "16px"
        },
    };
});
exports.BaseArrow = (0, styles_1.styled)("button")(({ theme }) => ({
    position: "absolute",
    zIndex: 1,
    top: "50%",
    transform: "translateY(-50%)",
    width: "32px",
    height: "32px",
    borderRadius: 8,
    border: "1px solid #ddd",
    backgroundColor: theme.palette.grayScale.white,
    boxShadow: theme.shadows[2],
    cursor: "pointer"
}));
exports.RightArrow = (0, styles_1.styled)(exports.BaseArrow)(() => ({
    right: 24
}));
exports.LeftArrow = (0, styles_1.styled)(exports.BaseArrow)(() => ({
    left: 24
}));
